import { client } from '@api/client';

import { TDefaultDTO } from '@interfaces/common/defaultDTO';
import { IItemsResponse } from '@interfaces/common/response';
import { IErrorCodesFormValues, IResponseError } from '@interfaces/errors/apiErrors';

import { URL } from './urls';

const {
	errors,
	errorsFilter,
	errorCodeEdit,
} = URL;

export const getErrors = (): Promise<IResponseError> => client.get(`/${errors}`);

export const getErrorsByFilters = ({
	page,
	pageSize,
	sortDirection,
	sortFieldName,
	searchValue,
}: Partial<TDefaultDTO>): Promise<IItemsResponse<IResponseError>> => {
	return client.get(`/${errorsFilter}`, {
		params: {
			page,
			pageSize,
			sortDirection,
			sortFieldName,
			searchValue,
		},
	});
};

export const editErrorCode = (dto: IErrorCodesFormValues): Promise<void> => {
	return client.put(`/${errorCodeEdit}/${dto.id}`, dto);
};
